import { FC } from 'react'

import { List, ListItem, Stack, Typography } from '@forto-dev/phoenix-ui-core/common'
import { Layout } from '@forto-dev/phoenix-ui-core/ship'

import { Footer } from '@/fragments/footer'
import { Header } from '@/fragments/header'
import { Navigation } from '@/fragments/navigation'
import { useLocalisation } from '@/utils/localisation'

import { EmailSettings } from './email/email'
import { PasswordSettings } from './password/password'
import { PersonalSettings } from './personal/personal'
import { Preferences } from './preferences/preferences'

export const Settings: FC = () => {
  const { translate } = useLocalisation()

  return (
    <Layout
      header={<Header />}
      navigation={<Navigation />}
      title={<Typography variant="h4">{translate('settings.title')}</Typography>}
      sidebar={
        <List>
          <ListItem icon="Person" href="#personal">
            {translate('settings.links.personal')}
          </ListItem>
          <ListItem icon="Email" href="#email">
            {translate('settings.links.email')}
          </ListItem>
          <ListItem icon="Lock" href="#password">
            {translate('settings.links.password')}
          </ListItem>
        </List>
      }
      main={
        <Stack gap={16}>
          <div id="personal">
            <PersonalSettings />
          </div>
          <div id="email">
            <EmailSettings />
          </div>
          <div id="password">
            <PasswordSettings />
          </div>
          <div id="preferences">
            <Preferences />
          </div>
        </Stack>
      }
      footer={<Footer />}
    />
  )
}
